import { oriasQueryKeys } from "@src/data/infoSocieteOrias/hook/oriasQuery.keys";
import { GatewayInfoSocieteOriasApi } from "@src/data/infoSocieteOrias/infoSocieteOrias.api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

/**
 * Statuts servis par le cache de la gateway. Interrogée même sans siren : elle
 * ne collecte alors rien, mais rapporte la date du dernier appel ORIAS et son
 * verdict, que le bandeau doit afficher dans tous les cas.
 *
 * `keepPreviousData` : la liste des sirens grossit au fil du balayage
 * progressif des contrôles ; sans lui, chaque page ferait clignoter le bandeau.
 */
export function useInfoSocietesOriasQuery(sirens: string[]) {
  return useQuery({
    queryKey: oriasQueryKeys.list(sirens),
    queryFn: () =>
      GatewayInfoSocieteOriasApi.getCachedInfoSocietesOriasBySirens(sirens),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    meta: {
      errorMessage: "Impossible de récupérer les informations ORIAS",
    },
  });
}
